import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactModal from "react-modal";
import { Table, Spinner, Alert, Button } from "react-bootstrap";
import { descargarDocumento } from "./Seguridad/DescargarDocumento";

ReactModal.setAppElement("#root"); // Accesibilidad obligatoria

const InformesRepositorio = (props) => {
  const [informes, setInformes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchInformes = async () => {
      try {
        const url = `https://suadesarrollo.azurewebsites.net/api/ObtenerInformesRepositorio?InstitucionId=${props.idinstitucion}&SolicitudId=${props.idSolicitud}`;
        const response = await axios.get(url, {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
          headers: {
            "Content-Type": "application/json",
          },
        });

        setInformes(response.data || []);
      } catch (err) {
        console.error("❌ Error al obtener informes:", err);
        setError("Error al obtener informes o aún se están generando...");
      } finally {
        setLoading(false);
      }
    };

    fetchInformes();
  }, []); // 👈 aquí está la clave

  return (
    <div>
      {/* 🔘 Botón para abrir modal */}
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={() => setIsModalOpen(true)}
      >
        Consulta
      </button>

      {/* 🪟 Modal con tabla */}
      <ReactModal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        style={{
          content: {
            maxWidth: "800px",
            margin: "auto",
            borderRadius: "15px",
            padding: "20px",
          },
          overlay: { backgroundColor: "rgba(0,0,0,0.5)" },
        }}
      >
        <br></br> <br></br>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5>📄 Informe</h5>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => setIsModalOpen(false)}
          >
            Cerrar
          </Button>
        </div>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
            <p>Cargando informes...</p>
          </div>
        ) : error ? (
          <Alert variant="warning">{error}</Alert>
        ) : informes.length === 0 ? (
          <Alert variant="info">
            {" "}
            No hay informes disponibles. <br />
            Comuníquese con el administrador del sistema y valide si ya fue
            generado su informe..
          </Alert>
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>

                <th>Fecha Informe</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {informes.map((informe) => (
                <tr key={informe.id}>
                  <td>{informe.id}</td>
                  <td>{informe.nombre}</td>

                  <td>
                    {new Date(informe.fechaInforme).toLocaleDateString("es-CO")}
                  </td>
                  <td>
                    <td>
                      <button
                        className="btn btn-success"
                        onClick={() => descargarDocumento(informe.ubicacion)}
                      >
                        Descargar: {informe.ubicacion}
                      </button>
                    </td>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </ReactModal>
    </div>
  );
};

export default InformesRepositorio;
